/**
 * Helper para acciones Vuex con namespace
 */

/**
 * Crea un wrapper para acciones que necesitan dispatch global
 * @param {Object} context - Contexto Vuex
 * @returns {Object} Helpers para dispatch/commit
 */
export const createVuexHelpers = (context) => {
    const { dispatch, commit, rootState } = context;

    return {
        /**
         * Dispatch a acción global
         * @param {string} actionName - Nombre de la acción
         * @param {any} payload - Payload opcional
         * @returns {Promise}
         */
        dispatchGlobal: async (actionName, payload = null) => {
            return await dispatch(actionName, payload, { root: true });
        },

        /**
         * Commit a mutación global
         * @param {string} mutationName - Nombre de la mutación
         * @param {any} payload - Payload
         */
        commitGlobal: (mutationName, payload) => {
            return commit(mutationName, payload, { root: true });
        },

        /**
         * Acceso al estado global
         */
        rootState,
        /**
         * Dispatch seguro con múltiples intentos
         */
        safeDispatch: async (actionName, payload = null) => {
            try {
                // Intento 1: Con root:true
                return await dispatch(actionName, payload, { root: true });
            } catch (error1) {
                try {
                    // Intento 2: Directo al store
                    if (rootState._vm && rootState._vm.$store) {
                        return await rootState._vm.$store.dispatch(
                            actionName,
                            payload
                        );
                    }
                    throw new Error("Store no disponible");
                } catch (error2) {
                    throw error2;
                }
            }
        },
    };
};

/**
 * Mixin para componentes Vue
 */
export const VuexGlobalMixin = {
    methods: {
        /**
         * Dispatch a acción global desde componente
         */
        $dispatchGlobal(actionName, payload = null) {
            return this.$store.dispatch(actionName, payload, { root: true });
        },

        /**
         * Commit a mutación global desde componente
         */
        $commitGlobal(mutationName, payload) {
            return this.$store.commit(mutationName, payload, { root: true });
        },

        /**
         * Acceso rápido a acciones namespaced
         */
        $dispatchNamespaced(moduleName, actionName, payload = null) {
            return this.$store.dispatch(`${moduleName}/${actionName}`, payload);
        },
    },
};
